import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router";
import InscricaoService from "../../services/Inscricoes/InscricaoService";
import { Clock, AlertCircle, Home, FileText, Loader2 } from "lucide-react";
import { Button } from "../../components/ui";

function PendentePay() {
    const location = useLocation();
    const [statusEnvio, setStatusEnvio] = useState('processando');
    const [mensagemApi, setMensagemApi] = useState(null);
    const [orderId, setOrderId] = useState(null);

    useEffect(() => {
        const processarPagamento = async () => {
            const params = new URLSearchParams(location.search);
            const dadosDoRedirect = {};

            for (const [key, value] of params.entries()) {
                dadosDoRedirect[key] = decodeURIComponent(value);
            }

            if (Object.keys(dadosDoRedirect).length === 0) {
                setStatusEnvio('erro');
                setMensagemApi('Nenhum parâmetro de confirmação encontrado.');
                return;
            }

            setOrderId(dadosDoRedirect.merchant_order_id || dadosDoRedirect.payment_id);

            const realStatus = dadosDoRedirect.collection_status || dadosDoRedirect.status;
            if (realStatus === 'approved') {
                window.location.href = `/pagamento/sucesso${location.search}`;
                return;
            }
            if (realStatus === 'rejected') {
                window.location.href = `/pagamento/falha${location.search}`;
                return;
            }

            try {
                const hoje = new Date();
                const year = hoje.getFullYear();
                const month = String(hoje.getMonth() + 1).padStart(2, '0');
                const day = String(hoje.getDate()).padStart(2, '0');
                const dataFormatada = `${year}-${month}-${day}`;

                const data = {
                    status: "Pendente",
                    data_pagamento: dataFormatada,
                    uuid_transacao: dadosDoRedirect.payment_id || dadosDoRedirect.collection_id || dadosDoRedirect.preference_id,
                    metodo_pagamento: dadosDoRedirect.payment_type,
                    id_corrida: sessionStorage.getItem('brv-id-corrida'),
                };

                const inscricaoService = new InscricaoService();
                const response = await inscricaoService.updateInscricao(JSON.stringify(data), sessionStorage.getItem('brv-id-inscricao'));

                if (response.ok) {
                    const resultado = await response.json();
                    setStatusEnvio('sucesso');
                    setMensagemApi(resultado.mensagem || 'Pagamento em análise pela instituição bancária.');
                } else {
                    const erro = await response.json();
                    setStatusEnvio('erro');
                    setMensagemApi(erro.mensagem || 'O servidor respondeu com um erro.');
                }
            } catch (error) {
                setStatusEnvio('erro');
                setMensagemApi('Falha ao comunicar com o servidor. Verifique a conexão.');
            }
        };

        processarPagamento();
    }, [location.search]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-urb-dark px-4 py-12">
            <div className="max-w-md w-full bg-urb-card border border-urb-border rounded-2xl p-8 shadow-2xl text-center">
                {statusEnvio === 'processando' && (
                    <div className="flex flex-col items-center gap-4 py-8">
                        <Loader2 className="w-12 h-12 text-blue-400 animate-spin" />
                        <h2 className="text-xl font-bold text-white">Processando Informações...</h2>
                        <p className="text-sm text-slate-400">
                            Aguarde, estamos confirmando os dados com nosso servidor.
                        </p>
                    </div>
                )}

                {statusEnvio === 'sucesso' && (
                    <div className="flex flex-col items-center gap-4">
                        <div className="w-20 h-20 rounded-full bg-amber-500/10 border border-amber-500/30 flex items-center justify-center text-amber-500 shadow-lg">
                            <Clock className="w-10 h-10" />
                        </div>

                        <h2 className="text-2xl font-extrabold text-white mt-1">Pagamento Pendente</h2>
                        <p className="text-sm text-amber-400 font-medium">
                            {mensagemApi || 'Seu pagamento está aguardando confirmação bancária.'}
                        </p>

                        {orderId && (
                            <div className="p-3 rounded-xl bg-slate-900 border border-urb-border text-xs text-slate-300 w-full">
                                Pedido ID: <strong className="text-white font-mono">{orderId}</strong>
                            </div>
                        )}

                        <p className="text-xs text-slate-400 leading-relaxed">
                            Assim que o pagamento for compensado pelo banco, sua inscrição será aprovada automaticamente.
                        </p>

                        <div className="flex flex-col sm:flex-row gap-3 w-full mt-2">
                            <Link to="/minhas-corridas" className="flex-1">
                                <Button className="w-full flex items-center justify-center gap-2 font-bold py-3 shadow-neon">
                                    <FileText className="w-4 h-4" />
                                    Minhas Corridas
                                </Button>
                            </Link>
                            <Link to="/" className="flex-1">
                                <Button variant="secondary" className="w-full flex items-center justify-center gap-2 font-bold py-3">
                                    <Home className="w-4 h-4" />
                                    Início
                                </Button>
                            </Link>
                        </div>
                    </div>
                )}

                {statusEnvio === 'erro' && (
                    <div className="flex flex-col items-center gap-4">
                        <div className="w-20 h-20 rounded-full bg-red-500/10 border border-red-500/30 flex items-center justify-center text-red-500">
                            <AlertCircle className="w-10 h-10" />
                        </div>
                        <h2 className="text-2xl font-bold text-white">Erro de Comunicação</h2>
                        <p className="text-sm text-slate-300">{mensagemApi}</p>

                        <Link to="/home" className="w-full mt-2">
                            <Button variant="secondary" className="w-full py-3">
                                Voltar para o Início
                            </Button>
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
}

export default PendentePay;
